import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { endpointsURL } from "../constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class DescargaFicheroConcesionarioService {
  env = environment.env;
  descargasFicheroConcesionario = endpointsURL.descargasFicheroConcesionario;

  constructor(private httpClient: HttpClient) {}

  public getFile() {
    return this.httpClient.get(
      `${this.env}${this.descargasFicheroConcesionario}/download`,
      {
        responseType: "blob",
      }
    );
  }
}
